import SmokeFreeJourney from "./SmokeFreeJourney";

export default SmokeFreeJourney;
